import TextSlider from './TextSlider';

export default function MarketingTemplate(): JSX.Element {
  return (
    <div className='flex flex-col h-full py-4'>
      <div className='flex-1 flex flex-col justify-center mt-16 mb-4 xl:mt-0 xl:mb-36 text-center xl:text-left'>
        <div className='xl:block'>
          <h2 className='font-bold text-4xl xl:text-6xl tracking-tight mb-2 '>
            All-in-one
          </h2>
          <h2 className='font-bold text-4xl xl:text-6xl tracking-tight pt-2 xl:pt-4 mb-2'>
            communications
          </h2>
        </div>

        <h2 className='flex flex-col xl:flex-row justify-center xl:items-start items-center xl:justify-start whitespace-nowrap content-center font-bold text-4xl xl:text-6xl tracking-tight'>
          <div className='pt-2 pb-4 xl:pt-4 xl:pb-0'>app for</div>
          <div className='relative overflow-hidden w-80 xl:w-128 h-20 xl:h-full ml-4'>
            <TextSlider />
          </div>
        </h2>
      </div>
      <div>
        <p className='font-medium text-lg text-gray text-center xl:text-left mb-4 xl:mb-0'>
          Communikit is a mobile framework that helps communities <br />
          communicate with their large membership groups.{' '}
          <a className='text-green' href='https://marketing.communikit.ca'>
            Learn More!
          </a>
        </p>
      </div>
    </div>
  );
}
